import { RouteComponentProps } from 'react-router';
import {ParsedQuery} from 'query-string'
import { IObservableObject } from 'mobx';
import { EventEmitter } from 'events';

interface MatchParams {
    flowName?: string;
}

export interface UIRendererProps extends RouteComponentProps<MatchParams> {
    flowName?: string; // used to override flowName
    domainDataId?: string; // used to override domain object id
}

export interface UIRendererState {
    uiMetadata: IUIViewDef|null,
    popupViewMetadata:IUIViewDef|null,
    customCss: string,
    flowName: string,
    PopupViewName: string,
    tla: string|null,
    domainDataId: string|null,
    hashedId:string|null,
    channelCode: string|null,
    queryParams?: ParsedQuery,
    errorComponent?: JSX.Element,
    isFetching?: boolean,
    error?: string,
}

export interface IBillerDef {
	clientCode:string;
	contactDayPhone:number;
	contactDayPhoneExt:number;
	contactEveningPhone:number;
	contactEveningPhoneExt:number;
	contactEmail:string;
	languageCode:string;
	addressLine1:string;
	addressLine2:string;
	city:string;
	state:string;
	zipCode:string;
	country:string;
	countryCode:string;
	createdBy:string;
	createdOn:string; // e.g "2021-02-22T17:22:53"
	modifiedBy:string;
	modifiedOn:string;
	activeFlag:boolean;
	
	tla:string;
	name:string;
	logo:string;
	appUrl:string;

};

// plugin data type
export interface CustomerWallet {
    LastUsedPm:boolean;
	ClientCode:string;
    ProfileId:number;
    ProfileCode:string; 
    PaymentTypeId:number; 
    PaymentMethodId:number;
	PaymentMethodType:string;
	PaymentMethodTypeDescr:string;
	FiName:string;
	CardHolderName:string;
    CcExpiryDate:string;
    MaskedAccountNumber:string;
    BankTransitNumber:string; 
    LastUsed:string; 
}
// plugin data
export interface PaymentMethodDef{
	ClientCode:string;
	PaymentMethodConfigId:number;
	PaymentMethodTypeCode:string;
	OrderBy:number;
	PaymentProcConfigId:number;
	PaymentProcCode:string;
	CxSegmentTypeCode:string;
	CnvFeeSplitPayEnabled:boolean;
	CnvFeeClientCode:string;
	MinPaymentAmount:number;
	MaxPaymentAmount:number;
	TokenizedProfile:boolean;
	GlobalProfileSupported:boolean;
	ActiveFlag:boolean;
	CreatedBy:string;
	CreatedOn:string;
	ModifiedBy:string;
	ModifiedOn:string;
	// private List<PaymentMethodChannelDef> paymentMethodChannel;
    // private PaymentProcConfigDef paymentProcConfig;
}

// plugin data
export interface PaymentTypeDef {

}
export type PluginData = {
    AccountInput: {
        liabilityFileSupported:boolean;
        paymentTypes: PaymentTypeDef[];
    }
    PaymentMethod?: {
        customerWallets: CustomerWallet[];
        paymentMethodDef: PaymentMethodDef[];
        
        payWithPreviousPmSupported?:boolean;
        
        amazonClientId?:string;
        amazonMerchantId?:string;
        amazonSandbox?:string;

        brainTreeEnvironment?:string;

        venmoProfileId?:string;
    }
} & {[key:string]: {[key:string]:any}};

/**
 * key is event name.e.g onClick.
 */
export interface EventProps {
    [key:string]: Function[];
}

export interface IDataAttribute {
    referenceMetadata:IDomainMetadata;
}
export interface IDomainMetadata {
    objectName: string;
    referenceName: any;
    maxCardinality?: number;
    /** key: domain object name */
    referenceAttributes: {[key:string]:IDataAttribute};
    children: IDomainMetadata[];

    attributes: {
                    name:string;
                    domainDataType?:string;
                } [];
}

export interface GridWidthProps {
    xs:string;
    sm:string;
    md:string;
    lg:string;
}

export interface IUIComponentDef {
    type: string; // component type name
    properties:GridWidthProps;
    binding: string;
	pluginName:string;
	parentQuestion:string;
	parentTrigger:string;
	cssClasses:string;
	componentId:string;
}

export interface IUICompositeComponentDef extends IUIComponentDef {
    children:IUIComponentDef[];
}

export interface IUIAccountInputDef extends IUIComponentDef {
    type:'AccountInput';
    title:string;
    paymentTypeDisplay:string;
    showFind:boolean;
}

export interface IUIButtonDef extends IUIComponentDef {
    type:'Button';
    label:string;
    size:string;
    url:string;
    target:string;
    eventTag:string;
    onClick:string[];
}
export interface IUIBaseImageDef extends IUIComponentDef {
    src:string;
    altText:string;
    text:string;
    height:string;
    width:string;
    imageCSSClasses:string;
    textCSSClasses:string;
}
export interface IUIImageDef extends IUIBaseImageDef {
    type:'Image';
}
export interface IUIDomainImageDef extends IUIBaseImageDef {
    type:'DomainImage';
}

export interface IUIHtmlLinkDef extends IUIComponentDef {
    type:'HtmlLink';
    label:string;
    url:string;
    target:string;
}

export interface IUIBaseInputDef extends IUIComponentDef {
	disabled:boolean;
	label:string;
	inputType:string;
	validate:boolean;
	required:boolean;
	maxLength:number;
	minLength:number;
	autofocus:boolean;
	value:string;
	readonly:boolean;
	icon:string;
	controlType:string;
	placeholder:string;
	validateFn:string;
	onChange:string;
	hideEmpty:boolean;
	autoComplete:string;
}

    export interface IUICheckboxDef extends IUIBaseInputDef {
        type:'Checkbox';
    }
    export interface IUICheckboxColDef extends IUIBaseInputDef {
        type:'CheckboxCol';
        width:string;
    }
    export interface IUIDateDef extends IUIBaseInputDef {
        type:'Date';
        min:string;
        max:string;
        format:string;
    }
    export interface IUIDateColDef extends IUIBaseInputDef {
        type:'DateCol';
        width:string;
        format:string;
    }
    export interface IUIDateTimeDef extends IUIBaseInputDef {
        type:'DateTime';
        width:string;
        format:string;
    }
    export interface IUIDateTimeColDef extends IUIBaseInputDef {
        type:'DateTimeCol';
        width:string;
        format:string;
    }

    export interface IUIDropDownDef extends IUIBaseInputDef {
        type:'DropDown';
        icon:string;
        valueList:string;
    }
    export interface IUIDropdownColDef extends IUIBaseInputDef {
        type:'DropdownCol';
        width:string;
        icon:string;
        valueList:string;
    }

    export interface IUIEmailDef extends IUIBaseInputDef {
        type:'Email';
    }
    export interface IUIEmailColDef extends IUIBaseInputDef {
        type:'EmailCol';
        width:string;
    }

    export interface IUIBaseNumberDef extends IUIBaseInputDef {
        scale:number;
        length:number;
        showGroupSeparator:boolean;
    }

        export interface IUICurrencyDef extends IUIBaseNumberDef {
            type:'Currency';
        }
        export interface IUICurrencyColDef extends IUIBaseNumberDef {
            type:'CurrencyCol';
            width:string;
        }
        export interface IUINumberDef extends IUIBaseNumberDef {
            type:'Number';
        }
        export interface IUINumberColDef extends IUIBaseNumberDef {
            type:'NumberCol';
            width:string;
        }
        export interface IUIPhoneNumberDef extends IUIBaseNumberDef {
            type:'PhoneNumber';
        }
        export interface IUIPhoneNumberColDef extends IUIBaseNumberDef {
            type:'PhoneNumberCol';
            width:string;
        }

    export interface IUIRadioDef extends IUIBaseInputDef{
        type:'Radio';
        icon:string;
        options:string;
        valueList:string;
    }        
        export interface IUIRadioColDef extends IUIBaseInputDef{
            type:'RadioCol';
            width:string;
            icon:string;
            options:string;
        }        

        export interface IUISwitchDef extends IUIBaseInputDef{
            type:'Switch';
            labelPosition:string;
        }
        export interface IUISwitchColDef extends IUIBaseInputDef{
            type:'SwitchCol';
            width:string;
        }

        export interface IUITextInputDef extends IUIBaseInputDef {
            type:'TextInput';
            validateFn:string;
        }
        export interface IUITextInputColDef extends IUIBaseInputDef {
            type:'TextInputCol';
            validateFn:string;
            width:string;
        }

export interface IUIPaymentMethodDef extends IUIComponentDef {
    type:'PaymentMethod';
    validPaymentMethods:string[];
}

export interface IUIPaymentTypeDef extends IUIComponentDef {
    type:'PaymentType';
}

export interface IUIPlainTextDef extends IUIComponentDef {
    type:'PlainText';
    messageKey:string;
}

export interface IUIRichTextDef extends IUIComponentDef {
    type:'RichText';
    html:string;
    htmlDecriptedMsg:string;
}

export interface IUITextBoxDef extends IUIComponentDef {
    type:'TextBox';
    messageKey:string;
}


export interface IUIContainerDef extends IUICompositeComponentDef {
    type:'Container';
    title:string;
    children: IUIContainerRowDef[];
}

export interface IUIContainerColDef extends IUICompositeComponentDef {
    type:'ContainerCol';
}

export interface IUIContainerRowDef extends IUICompositeComponentDef {
    type: 'ContainerRow';
}

export interface IUIFormDef extends IUICompositeComponentDef {
    type:'Form';
    title:string;
    children: IUIContainerDef[];
}

export type AllowSelectionEnum = 'NONE'|'SINGLE'|'MULTIPLE'|'SINGLE_NONE';

export interface IUIRepeatableSectionDef extends IUICompositeComponentDef {
    title:string;
    listBinding:string;
    onSelectionChange:string[];
    maxItems:number;
    enableUpDown:boolean;
    orderBy:string;
    sortBy:string;

    enableDeselect:boolean;
    deselectLabel:string;

    addIcon:string|null;
    addLabel:string|null;
    deleteIcon:string|null;
    allowSelection: AllowSelectionEnum;

    filter:string;
    childViewName:string;
    
    editIcon:string;
    editChildViewName:string;

    innerWidth:GridWidthProps;
}

    export interface IUIDataGridDef extends IUIRepeatableSectionDef {
        type:'DataGrid';
        enableAdd:boolean;
        enableEdit:boolean;
        enableDelete:boolean;
        childViewName:string;
        children:IUIBaseInputDef[];
    }

    export interface IUIRepeatableContainerDef extends IUIRepeatableSectionDef {
        type: 'RepeatableContainer';
    }

    export interface IUIRepeatableFormDef extends IUIRepeatableSectionDef {
        type: 'RepeatableForm';
    }

export interface IUISplitColumnDef extends IUICompositeComponentDef {
    type:'SplitColumn';
    title:string;
    children:IUIViewColDef[];
}
export interface IUIViewColDef extends IUICompositeComponentDef {
    type:'ViewCol';
    children: IUIFormDef[];
}
export interface IUIViewHeaderDef extends IUICompositeComponentDef {
    type:'ViewHeader';
}
export interface IUIViewFooterDef extends IUICompositeComponentDef {
    type:'ViewFooter';
}
export interface IUIViewRowDef extends IUICompositeComponentDef {
    type:'ViewRow';
    children: IUIViewColDef[] | IUIContainerRowDef[];
}

export interface IUIViewDef extends IUICompositeComponentDef {
    type:'View';
    title:string;
    version:string;
    tla:string;
    cssFile:string;
    domainObjectName:string;
    name:string;
    popup:boolean;
    width:string;
    /** children is IUIViewRowDef[] for basic view */
    children: IUIViewRowDef[]|(IUIViewHeaderDef|IUIViewFooterDef|IUISplitColumnDef)[];
}

export interface IFlowComponent {
    type:'FlowViewList';
    viewName:string;
}
export interface IFlowMetadata{
    type:'UIFlow';
    tla:string;
    name:string;
    description:string;
    domainObjectName:string;
    enableChatbot:boolean;
    version:string;
    children:IFlowComponent[];
}

export interface IFlowItem {
    sequence:number;
    flowName:string;
    id:string; // domain data id
    hashId:string;
    lastViewName:string;
}

/**
 * key is one of (1) system properties such as _deleted, _edgeName, _errors, etc. 
 * (2) scalar attribute name (3) child domain object name, (4) reference name of referenced object.
 * Value is one of scalar values, a domain data, or an array of domain data.
 * 
 */
export type IDomainData = {
    _deleted?: boolean;
    _edgeName?: string;
    _errors?: {[key:string]:any};
    Id?: string;
} & {[key:string]: string|number|boolean|null|IDomainData | IDomainData[]};

/**
 * fake or initial Id (as string) starts with '-'.
 * 
 * @param id domain data Id attribute value.
 */
export function hasRealDomainDataId(id:string|number|undefined|null):boolean {
    return !!id && !(id.toString().startsWith('-'));
}

export function isNewObject(item:IDomainData){
    return !hasRealDomainDataId(item.Id);
  }

export type IPaymentType = {
    AccountRequiredFlag:string;
    PaymentTypeCode:string;
    accountNumber:string;
    authToken1:string;
    authToken2:string;
    authToken3:string;
    accountToken:string;
    AccountNumberLabel:string;
    AccountTokenLabel:string;
    AccountTokenEnabled:boolean;
    LiabilityToken1Enabled:boolean;
    LiabilityToken2Enabled:boolean;
    LiabilityToken3Enabled:boolean;
} & IDomainData;

/* e.g
disabled: null
domainAttribute: "PaperSuppressedFlag"
domainId: null
domainObject: "CustomerAccount"
hide: true
readonly: null
uicomponentId: null

*/
/**
 * UI instruction is used to (1) override ui component metadata and (2) hide ui component.
 * If view domain object is Payment, the backend calls PaymentRuleEngine.generateRules to generate UI instructions.
 * If view domain object is Customer, the backend calls CustomerRuleEngine.generateRules to generate UI instructons.
 */
// TODO: java backend should send back type !!!
export interface IUIInstruction {
    /** matching domain object name */
    domainObject?:string;
    /** matching domain object attribute name */
    domainAttribute?:string;

    /** new ui component id */
    uicomponentId?:string;
    /** new domain object id */
    domainId?:string;
    /** to hide the ui component? */
    hide?:boolean;

    /** InputUIInstruction */
    readonly?: boolean;
    /** InputUIInstruction */
    disabled?: boolean;

    /** RepeatableUIInstruction */
    minCardinality?: number;
    /** RepeatableUIInstruction */
    maxCardinality?: number;
    /** RepeatableUIInstruction. what is it ??? example??? */
    filter?: string;
    /** RepeatableUIInstruction */
    selectionType:AllowSelectionEnum;
}

/**
 * If view domain object is Payment, backend calls PaymentRuleEngine.generateNavigationRules to generate navigation instruction.
 * For example, 
 * <code>
 *     	if(domainObject.getBoolean("HasDuplicate") == true) {
    		String viewName = "duplicate-payment";
    		if(StringUtilsExt.equals(channelCode, "AD")) viewName = "ad-duplicate-payment";
    		else if(StringUtilsExt.equals(channelCode, "CP_WEB")) viewName = "cp-duplicate-payment";
    		navInstructionList.add(navigationInstructionGenerator.initViewNavigationInstruction(viewName));
        }
   </code>        
 */
export interface IUINavigationInstruction {
    flowName: undefined;
    /** next view name */
    viewName:string;
}

export interface IValueList {

}

export interface DomainDataValueChangeEvent{
    changeType: 'NEW'|'UPDATE'|'DELETE';
    parentObjectId?:string;
    objectId:string;
    objectName:string;
    attributeName:string;
    /** needed by front end to identify target domain data */
    edgeName:string;
    /** needed by front end to identify target domain data */
    parentEdgeName:string;

    /** This will be for objects that are in a list */
    index:number|null;

    previousValue:IDomainData|string|number|boolean|null|undefined;
    newValue:IDomainData|string|number|boolean|null|undefined;
}

export type UIEvent = string | DomainDataValueChangeEvent;  

/**
 * partial flattern domain data map. key is edget name of domain data tree.
 */
export type FlatDomainDataContext = {
    [key:string]: {
        data:IDomainData|IDomainData[], 
        metaData:IDomainMetadata
    }
};

/**
 * View context object. property key is view name.
 */
export type IViewContext = {
    triggers:{parentTriggerEvent?: EventEmitter};
} & {[key:string]:FlatDomainDataContext};

export type ICloneContext = {[key:string]:IDomainData};

export type IContextObject = {
    operation: string; // e.g 'Add', 'Edit'
    newCtx:FlatDomainDataContext;
    id: string;
};


export interface IUIState {
    flowName:string;
    description:string;
    clientCode:string;
    channelCode:string;
    subSystem:string;
    currentViewName:string;
    parentViewName:string;
    currentObjectId:string;
    currentObjectName:string;
    domainObjectName:string;
    actionMessages:{[key:string]:string};
    clientConfigOptions:{[key:string]:string};
    googleSiteId: string;
    billerInfo:IBillerDef;
    flowStack:IFlowItem[];
    pluginData: PluginData;
    domainObjectMetadata:IDomainMetadata;
    viewMetadataList:IUIViewDef[];
    flowMetadata:IFlowMetadata;
    domainObject:IDomainData;
    instructionList:IUIInstruction[];
    navigationInstruction:IUINavigationInstruction[];
    valueListStore:{[key:string]:IValueList};
    jwtToken:string;
    globalCss:string;

    events?: UIEvent[];
}

export interface BackendErrorMessage {
    objectName?:string;
    attributeName?:string;
    objectId?: string;

    /** Code will be used by i18n files for displaying the message in user's language */
    code?:string;
    message:string;
    type:'ERROR'|'WARNING';
}

/**
 * backend ajax call response body.
 */
export interface ServiceResponseData<T> {
    result:T;
    clientCode?:string;
    error?: boolean;
    errorType?:string;
    errorMessage?: BackendErrorMessage[];
    /** for example, ["NEW_LIABILITY"] */
    // events?: any[];
}
export interface IUIOnly {
    enablePopUpView?: boolean;

    venmoState?: {
                    status:string|null, 
                    error?:{code:string, message:string}, 
                    category:string|null, 
                    payload:any, 
                    venmoInstance:any,
                    tokenLoaded:boolean
                }
}
export interface IFormBean{
    __ui__only: IUIOnly;
    
    hasError?:boolean;

    /** used by ObservableSpinner */
    isLoading?:boolean;
    loadingText?: string;

    getRendererState: () => UIRendererState;
    getRendererProps: () => UIRendererProps;
    contextualErrors: {[key:string]: any};
    errorCache: {[key:string]:any};
    validators: Function[];
    error5xx: ()=>void;
    eventMap: {}; // useless ?
    changeView?: (name:string, ctxObj?:IContextObject,callback?: (flag:boolean)=>void,cancel?:boolean) => void;
    switchFlow: (flowName:string, action:string) => Promise<void>;
    previousFlow: (action: string|null) => Promise<void>;

    FlowName:string;
    // description:string;
    ClientCode:string;
    ChannelCode:string;
    SubSystem:string;
    CurrentViewName:string;
    ParentViewName:string;
    CurrentObjectId:string;
    CurrentObjectName:string;
    DomainObjectName:string;
    actionMessages:{[key:string]:string};
    clientConfigOptions:{[key:string]:string};
    // googleSiteId: string;
    Biller:IBillerDef;
    FlowStack:IFlowItem[];
    /** all plugin data of the view */
    PluginData: PluginData; // TODO: what if there are more than one instance of the same plugin???
    DomainMetadata:IDomainMetadata;
    ViewMetadataList:IUIViewDef[];
    FlowMetadata:IFlowMetadata;
    DomainObject:{[key:string]:IDomainData};
    InstructionList:IUIInstruction[];
    NavigationInstructionList:IUINavigationInstruction[];
    valueListStore:{[key:string]:IValueList};
    JwtToken:string;
}

export type FormBean = IFormBean & IObservableObject;

export type UIState = IUIState & IObservableObject;

